import React from 'react'
import { css } from '@emotion/core'
import { SettingTab } from '@/components/molecules/settings/setting-tab'

const tabs = [
  {
    name: 'RestaurantManager.HighlightSettings',
    path: '/setting/restaurant/highlight',
  },
  {
    name: 'RestaurantManager.DisplaySubjects',
    path: '/setting/restaurant/display-subject',
  },
] as const

type RestaurantSettingTabName = (typeof tabs)[number]['name']

export const SettingRestaurantTab: React.FC<{ currentTab: RestaurantSettingTabName }> = ({ currentTab }) => (
  <SettingTab currentTab={currentTab} tabs={tabs} customTabStyle={tabStyle} />
)

const tabStyle = css({
  width: 160,
})
